import React from "react";
import '../../assets/css/Dentobook.css';
import {Organization} from "../../api-client";
import FormButtons from "../common/FormButtons";
import {Button} from "antd";
import {isMobileOnly} from "react-device-detect";
import {FormattedMessage, useIntl} from "react-intl";
import {getCountry} from "../../i18n/countries";

interface OrganizationDetailsViewProps {
    organization: Organization;
    setEditMode: Function;
}

const OrganizationDetailsView = ({organization, setEditMode}: OrganizationDetailsViewProps) => {
    const intl = useIntl();
    const countryData = getCountry(organization.country ?? '');
    const countryName = countryData ? (intl.locale === 'BG' ? countryData.name_bg : countryData.name_en) : organization.country;

    return (
        <div>
                <h3 className="dentobook-content font-weight-500 text-align-center"><FormattedMessage id="organization_details" /></h3>
                <p>Name: {organization.name || <FormattedMessage id="no_data" />}</p>
                <p>Email: {organization.email || <FormattedMessage id="no_data" />}</p>
                <p>Phone: {organization.phone || <FormattedMessage id="no_data" />}</p>
                <p>Address: {organization.address || <FormattedMessage id="no_data" />}</p>
                <p>Country: {countryName || <FormattedMessage id="no_data" />}</p>
                <p>Town: {organization.town || <FormattedMessage id="no_data" />}</p>
                {/* TODO: Parent organization hierarchy not implemented in backend */}
                {/* <p>Parent organization name: {organization.parent?.name || <FormattedMessage id="no_data" />}</p> */}
                <p>
                    Created at:{' '}
                    {organization.createdAt
                        ? new Date(organization.createdAt).toLocaleString()
                        : <FormattedMessage id="no_data" />
                    }
                </p>
            <FormButtons>
                <Button onClick={() => setEditMode(true)}
                        className={"edit-btn " + (isMobileOnly ? "mobile-update-btn" : "dentobook-btn-primary")}
                        type="primary"
                        size="large" shape="round"><FormattedMessage id="edit"/></Button>
            </FormButtons>
        </div>
    );
}

export default OrganizationDetailsView;